
import React, { useEffect, useState } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import
{
  Button,
  Col,
  Form,
  Modal,
  Row
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ENDPOINT } from "../../../axios/apiConfig";
import { postData, postFormData } from "../../../axios/apiHelper";
import { loader } from "../../../loader";
import RenderPdf from "../../Library/CreateChange/RenderPdf";
let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
//pdf id  3846
//ebook 3899
const newLanguage = {
  0: 'English',
  1: 'Italian',
  2: 'Germany',
  3: 'Spanish',
  4: 'Russian',
};
const VwdPreviewContent = () =>
{
  const rdLikeArray = ["56Ek4feL/1A8mZgIKQWEqg==", "bWmUjqX7J011   WUTYn9g==", "MXl8m36VZFYXpgFVz3Pg0g=="]
  const isLikeRdAccount = rdLikeArray.includes("FOkB/AUT2wGXRv ablqvbg==")
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [articleId, setArticleId] = useState(
    typeof state?.pdfId !== "undefined" ? state?.pdfId : ""
  );
  const [isEdit, setIsEdit] = useState(
    typeof state?.isEdit !== "undefined" ? state?.isEdit : 0
  );

  const [allowStateVideo, setAllowStateVideo] = useState(
    typeof state?.allowVideo !== "undefined"
      ? state?.allowVideo
        ? true
        : false
      : false
  );
  const [pdfData, setPdfData] = useState([]);
  const [editTitle, setEditTitle] = useState(false);
  const [publishStatus, setPublishStatus] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [titleChange, setTitleChange] = useState("");
  const [titleNew, setTitleNew] = useState("");
  const [scrolling, setScrolling] = useState(false);
  const [isDisableButton, setButton] = useState(false);
  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 5 },
  };
  const [activeIndex, setActiveIndex] = useState(0);
  const slidePrev = () => setActiveIndex(activeIndex - 1);
  const slideNext = () => setActiveIndex(activeIndex + 1);
  const syncActiveIndex = ({ item }) => setActiveIndex(item);
  const [templateId, setTemplateId] = useState();
  const [newTemplateClicked, setNewTemplateClicked] = useState(false);
  const [templateClickedd, setTemplateClicked] = useState(false);
  const [pdfFileId, setPdfFileId] = useState();
  const [templatePdf, setTemplatePdf] = useState();
  const [templateAllVersion, setTemplateAllVersion] = useState(0);
  const [nextFlag, setNextFlag] = useState(0);
  const [templateName, setTemplateName] = useState("");
  const [userInputs, setUserInputs] = useState({});
  const [updateFlag, setUpdateFlag] = useState(0);
  const [apiCallBackFlag, setApiCallBackFlag] = useState(0);
  const [isOptimizingStart, setStartOptimizing] = useState(false);
  const location = useLocation();
  // console.log(location,'publish page')
  const BrokenImage =
    "https://docintel.s3-eu-west-1.amazonaws.com/cover/default/default.png";
  const [isKey, setIsKey] = useState(0);

  useEffect(() =>
  {
    getArticleData();
  }, []);

  const startAndStopScrolling = () =>
  {
    setScrolling(!scrolling)
    setStartOptimizing(true)
  }

  const getArticleData = async () =>
  {
    try {
      loader("show");
      if (typeof articleId === "undefined") {
        if (state?.pdfId) {
          setArticleId(state?.pdfId);
        }
      }

      let body = {
        pdfId: typeof state?.pdfId !== "undefined" ? state?.pdfId : articleId,
      };
      const res = await postData(ENDPOINT.LIBRARYGETARTICLE, body);
      setPdfData(res?.data?.data);
      setApiCallBackFlag(apiCallBackFlag + 1);

      if (res?.data?.data?.file_type && res?.data?.data?.file_type == "pdf") {
        setNewTemplateClicked(true);
      }
      loader("hide");

      if (res?.data?.data?.file_type != "pdf") {
        setTimeout(function ()
        {
          const div_img = document.querySelector(
            ".alice-carousel__wrapper img"
          );
          if (typeof div_img !== "undefined" || div_img != null) {
            div_img.click();
          }
        }, 300);
      }
    } catch (err) {
      console.log("--err", err);
      loader("hide");
    }
  };

  const updateArticleTitle = async (title) =>
  {
    try {
      loader("show");
      let formData = new FormData();
      formData.append("pdfId", articleId);
      formData.append("type", pdfData?.file_type);
      formData.append("userId", "FOkB/AUT2wGXRv ablqvbg==");
      formData.append("title", title);
      if (pdfData?.file_type && pdfData.file_type == "ebook") {
        formData.append("fileId", pdfFileId);
      }
      await postFormData(ENDPOINT.UPDATE_PDF_FILE, formData, {
        header: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (pdfData?.file_type && pdfData.file_type == "ebook") {
        let pdfIndex = pdfData.ebookData.findIndex((el) => el.id === pdfFileId);
        pdfData.ebookData[pdfIndex].title = title;
        setPdfData(pdfData);
        setTemplateName(title);
        setTitleNew(title);
      } else {
        pdfData.title = title;
      }
    } catch (err) {
      console.log(err);
    } finally {
      loader("hide");
    }
  };

  const templateClicked = (template, e) =>
  {
    setIsKey((prevKey) => prevKey + 1);
    const div = document.querySelector("img.select_mm");
    setNewTemplateClicked(true);
    if (div) {
      div.classList.remove("select_mm");
    }

    if (pdfData?.file_type && pdfData.file_type == "ebook") {
      let pdfIndex = pdfData.ebookData.findIndex((el) => el.id === template.id);
      let nextItem = pdfData.ebookData[pdfIndex + 1];
      if (typeof nextItem !== "undefined") {
        setNextFlag(1);
      } else {
        setNextFlag(0);
      }
    } else {
      setNextFlag(0);
    }
    setPublishStatus(false);
    setTemplatePdf(template?.file_name);
    setTemplateName(template?.title);
    setTitleNew(template?.title);
    setTemplateClicked(true);
    setPdfFileId(template.id);
    setEditTitle(false);
    setTemplateAllVersion(template?.ie_allversion);
    e.target.classList.toggle("select_mm");
  };

  const handleClose = () =>
  {
    setShow(false);
  };

  const handleShow = () =>
  {
    if (pdfData?.file_type && pdfData.file_type == "ebook") {
      if (typeof pdfFileId === "undefined") {
        toast.warning("Please select the Ebook chapter.");
      } else {
        setShow(true);
      }
    } else {
      setShow(true);
    }
  };

  const handleChange = (e, isSelectedName) =>
  {
    setUpdateFlag(1);
    if (e?.target?.files?.length < 1) {
      return;
    }
    setUserInputs({
      ...userInputs,
      [isSelectedName ? isSelectedName : e?.target?.name]: isSelectedName
        ? e?.target?.files
          ? e?.target?.files
          : e?.target?.value
        : e?.target?.value,
    });
  };

  const uploadPdf = async (e) =>
  {
    e.preventDefault();

    try {
      loader("show");
      let formData = new FormData();
      formData.append("pdfId", articleId);
      formData.append("type", pdfData.file_type);
      formData.append("userId", "FOkB/AUT2wGXRv ablqvbg==");
      formData.append("file", userInputs?.uploadFile?.[0]);

      if (pdfData?.file_type && pdfData.file_type == "ebook") {
        if (typeof userInputs?.title != "undefined") {
          setTemplateName(userInputs?.title);
          formData.append("title", userInputs?.title);
        }

        formData.append("fileId", pdfFileId);
      }
      const res = await postFormData(ENDPOINT.UPDATE_PDF_FILE, formData, {
        header: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (pdfData?.file_type && pdfData.file_type == "ebook") {
        setUserInputs({ ...userInputs, title: "", uploadFile: "" });
      }

      if (pdfData?.file_type && pdfData.file_type == "ebook") {
        let pdfIndex = pdfData.ebookData.findIndex((el) => el.id === pdfFileId);
        pdfData.ebookData[pdfIndex].title = res?.data?.data?.title;
        pdfData.ebookData[pdfIndex].file_name = res?.data?.data?.pdf;
        setTemplatePdf(res?.data?.data?.pdf);
      } else {
        pdfData.file_name = res?.data?.data?.pdf;
        pdfData.title = res?.data?.data?.title;
        setTemplatePdf(res?.data?.data?.pdf);
      }
    } catch (err) {
      console.log("--err", err);
    } finally {
      loader("hide");
    }
    handleClose();
    setUpdateFlag(0);
    setPublishStatus(false);
  };

  const imageOnError = (event) =>
  {
    event.currentTarget.src = BrokenImage;
    event.currentTarget.className = "error";
  };

  const updatePublish = () =>
  {
    setPublishStatus(true);
  };

  const handleNext = async (obj) =>
  {
    loader("show");
    obj.append("pdfId", articleId);
    obj.append("user_id", "FOkB/AUT2wGXRv ablqvbg==");
    obj.append("type", pdfData?.file_type);
    obj.append(
      "from_vwd",true
    );
    if (pdfData.file_type == "ebook") {
      obj.append("pdfFileId", pdfFileId);
    }

    if (pdfData.file_type == "ebook" && templateAllVersion == 1) {
      try {
        let pdfIndex = pdfData.ebookData.findIndex((el) => el.id === pdfFileId);
        pdfData.ebookData[pdfIndex].processed = 1;
        let nextItem = pdfData.ebookData[pdfIndex + 1];
        if (typeof nextItem !== "undefined") {
          setPublishStatus(false);
          pdfData.ebookData[pdfIndex + 1].processed = 1;
          let get_next_id = nextItem.id;
          var link = document.getElementById("template_dyn" + get_next_id);
          link.click();
        } else {
          setPublishStatus(true);
          navigate("FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg==" ? "/vwd/content-detail" : "/content-detail", {
            // state: { pdfId: articleId,isEdit: isEdit },
            state: {
              pdfId: articleId, isEdit: isEdit,
              // title : location?.state?.title,
              title: isLikeRdAccount ? location?.state?.title : '',
              flag: isLikeRdAccount
                ? (location?.state?.flag === "Non-mandatory" ? 'Non-mandatory' : "mandatory")
                : '',
              draft: state?.draft
            },

          });
        }
        setPdfData(pdfData);
      } catch (err) {
        console.log(err);
      } finally {
        loader("hide");
      }
    } else {
      try {
        const res = await postFormData(ENDPOINT.ADD_PDF_WORD, obj, {
          header: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (pdfData?.file_type && pdfData.file_type == "ebook") {
          let pdfIndex = pdfData.ebookData.findIndex((el) => el.id === pdfFileId);
          pdfData.ebookData[pdfIndex].processed = 1;
          pdfData.ebookData[pdfIndex].image = res?.data?.data?.image;

          let nextItem = pdfData.ebookData[pdfIndex + 1];
          if (typeof nextItem !== "undefined") {
            setPublishStatus(false);
            pdfData.ebookData[pdfIndex + 1].processed = 1;
            let get_next_id = nextItem.id;
            var link = document.getElementById("template_dyn" + get_next_id);
            link.click();
          } else {
            setPublishStatus(true);
            navigate("FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg==" ? "/vwd/content-detail" : "/content-detail", {

              state: {
                pdfId: articleId, isEdit: isEdit,

                title: isLikeRdAccount ? location?.state?.title : '',
                flag: isLikeRdAccount
                  ? (location?.state?.flag === "Non-mandatory" ? 'Non-mandatory' : "mandatory")
                  : '',
                draft: state?.draft
              },

            });
          }
          setPdfData(pdfData);
        } else {
          setPublishStatus(true);
          navigate("FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg==" ? "/vwd/content-detail" : "/content-detail", {
            state: {
              pdfId: articleId, isEdit: isEdit,

              title: isLikeRdAccount ? location?.state?.title : '',
              flag: isLikeRdAccount
                ? (location?.state?.flag === "Non-mandatory" ? 'Non-mandatory' : "mandatory")
                : '',
              draft: state?.draft
            },

          });
        }
        setApiCallBackFlag(apiCallBackFlag + 1);
      } catch (err) {
        console.log(err);
      } finally {
        loader("hide");
      }
    }
  };


  return (
    <Col className="right-sidebar custom-change">
      <div className="custom-container">
        <Row>
          <div className="page-top-nav sticky">
            <div className="row justify-content-end align-items-center">
              <div className="col-12 col-md-1">
                <div className="header-btn-left">
                  {isLikeRdAccount ? (
                    <>
                      {allowStateVideo ? (
                        <Link
                          className="btn btn-bordered btn btn-primary"
                          to="/vwd/library-add-link"
                          state={{
                            pdfId: state?.pdfId,
                            isEdit: isEdit,
                            allowVideo: allowStateVideo,
                            flag: isLikeRdAccount
                              ? location?.state?.flag === "mandatory"
                                ? "mandatory"
                                : location?.state?.flag === "Non-mandatory"
                                  ? "Non-mandatory"
                                  : ""
                              : "",
                            title: isLikeRdAccount
                              ? location?.state?.title
                              : "",
                            draft: state?.draft,
                          }}
                        >
                          Back
                        </Link>
                      ) : (
                        <Link
                          className="btn btn-bordered btn btn-primary"
                          to="/vwd/library-create"
                          state={{
                            flag: isLikeRdAccount
                              ? location?.state?.flag === "mandatory"
                                ? "mandatory"
                                : location?.state?.flag === "Non-mandatory"
                                  ? "Non-mandatory"
                                  : ""
                              : "",
                            title: isLikeRdAccount
                              ? location?.state?.title
                              : "",
                            draft: state?.draft,
                          }}
                        >
                          Back
                        </Link>
                      )}
                    </>
                  ) : (
                    <Link
                      className="btn btn-bordered btn btn-primary"
                      // to="/set-popup"
                      to={
                        "FOkB/AUT2wGXRv ablqvbg==" ===
                          "FOkB/AUT2wGXRv ablqvbg=="
                          ? "/vwd/library-edit"
                          : "/set-popup"
                      }
                      state={
                        "FOkB/AUT2wGXRv ablqvbg==" ===
                          "FOkB/AUT2wGXRv ablqvbg=="
                          ? { pdfid: articleId }
                          : {
                            pdfId: state?.pdfId,
                            isEdit: isEdit,
                            allowVideo: allowStateVideo,
                            ibu: pdfData?.ibu ? pdfData?.ibu : "",
                            lng: pdfData?.popup_email_content_language
                              ? newLanguage[
                              pdfData?.popup_email_content_language
                              ]
                              : 10,
                            draft: state?.draft,
                          }
                      }
                    >
                      Back
                    </Link>
                  )}
                </div>
              </div>
              <div className="col-12 col-md-9">
                <ul className="tabnav-link">
                  {isEdit == 1 ? (
                    <>
                      {(!pdfData?.isPharmaOwner ||
                        pdfData?.isPharmaOwner !== 1) && (
                          <li className="">
                            <a href="">Edit Your Content</a>
                          </li>
                        )}

                      {allowStateVideo ? (
                        <li className="">
                          <a href="">[Embedding Video]</a>
                        </li>
                      ) : null}
                      {!isLikeRdAccount &&
                        "FOkB/AUT2wGXRv ablqvbg==" !==
                        "FOkB/AUT2wGXRv ablqvbg==" ? (
                        <li className="">
                          <a href="">Edit Consent Option</a>
                        </li>
                      ) : null}
                      <li className="active active-main">
                        <a href="">Approve Your Content &amp; Save</a>
                      </li>
                    </>
                  ) : (
                    <>
                      <li className="">
                        <a href="">Create Your Content</a>
                      </li>
                      {allowStateVideo ? (
                        <li className="">
                          <a href="">[Embedding Video]</a>
                        </li>
                      ) : null}
                      {!isLikeRdAccount &&
                        "FOkB/AUT2wGXRv ablqvbg==" !==
                        "FOkB/AUT2wGXRv ablqvbg==" ? (
                        <li className="">
                          <a href="">Edit Consent Option</a>
                        </li>
                      ) : null}

                      <li className="active active-main">
                        <a href="">Preview Your Content &amp; Publish</a>
                      </li>
                    </>
                  )}
                </ul>
              </div>
              <div className="col-12 col-md-2">
                <div className="header-btn">
                  <Button
                    onClick={() =>
                    {
                      setTrigger((trigger) => trigger + 1);
                    }}
                    className={
                      publishStatus
                        ? "btn btn-primary btn-filled next send_btn"
                        : "btn btn-primary btn-filled next btn-disabled"
                    }
                  >
                    {/* {isEdit == 1 ? "Save" : "Publish"} */}
                    {pdfData?.delete_status == 1 ? "Publish" : "Save"}
                  </Button>
                </div>
              </div>
            </div>
          </div>

          {apiCallBackFlag
            ? pdfData?.file_type &&
            pdfData.file_type == "ebook" && (
              <section className="select-mail-template library-cosent prev_content">
                <div className="custom-container">
                  <div className="page-title">
                    <h4>Select chapter to preview it</h4>
                  </div>
                  <AliceCarousel
                    mouseTracking
                    disableDotsControls
                    activeIndex={activeIndex}
                    responsive={responsive}
                    onSlideChanged={syncActiveIndex}
                  >
                    {pdfData?.ebookData.map((template, index) =>
                    {
                      return (
                        <React.Fragment key={index}>
                          <div
                            className={
                              index === 0 || template.processed == 1
                                ? "item"
                                : template.id == pdfFileId
                                  ? "item"
                                  : " item disable-link"
                            }
                            onClick={(e) => templateClicked(template, e)}
                            id={"click" + template.id}
                          >
                            <img
                              id={"template_dyn" + template.id}
                              src={template.image}
                              onError={imageOnError}
                              alt=""
                              className={
                                typeof templateId !== "undefined" &&
                                  templateId == template.id
                                  ? "select_mm"
                                  : ""
                              }
                            />
                            <p>{template.title}</p>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </AliceCarousel>
                </div>
              </section>
            )
            : null}
          <div className="create-change-content spc-content">
            <div className="form_action">
              <div className="row">
                <Col className="sublink_right preview-content d-flex flex-column">
                  <>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="edit_pdf_title">
                        <h4 className={editTitle ? "edit_content_title edit" : "edit_content_title "}>
                          {editTitle ? (
                            <input
                              type="text"
                              className="form-control"
                              id="new-tag"
                              value={titleChange}
                              onChange={(e) => setTitleChange(e.target.value)}
                            />
                          ) : pdfData?.file_type &&
                            pdfData.file_type == "ebook" ? (
                            templateName != "" ? (
                              templateName
                            ) : (
                              pdfData?.ebookData[0]?.title
                            )
                          ) : titleChange != "" ? (
                            titleChange
                          ) : (
                            pdfData?.title
                          )}

                          {editTitle ? (
                            <>
                              <button
                                className="btn btn-filled"
                                onClick={(e) =>
                                {
                                  setEditTitle(false);
                                  updateArticleTitle(titleChange);
                                }}
                              >
                                Save
                              </button>
                              <button
                                className="btn btn-bordered"
                                onClick={(e) =>
                                {
                                  setEditTitle(false);
                                  setTitleChange(pdfData?.title);
                                }}
                              >
                                Cancel
                              </button>
                            </>
                          ) : (
                            <>
                              {(!pdfData?.isPharmaOwner ||
                                pdfData?.isPharmaOwner !== 1) && (
                                  <button
                                    className="btn btn-edit"
                                    onClick={(e) =>
                                    {
                                      setEditTitle(true);
                                      setTitleChange(
                                        pdfData?.file_type &&
                                          pdfData.file_type == "ebook"
                                          ? templateName != ""
                                            ? templateName
                                            : pdfData?.title
                                          : pdfData?.title
                                      );
                                    }}
                                  >
                                    <img
                                      src={path_image + "edit-button.svg"}
                                      alt="Edit"
                                    />
                                  </button>
                                )}
                            </>
                          )}
                        </h4>
                      </div>
                      <div className="blink_text">
                        <h6>
                          Please verify every page is correct and press
                          'Publish' at the top right when you're sure.
                        </h6>
                        <Button
                          className={`btn btn-filled ${isDisableButton ? "" : "disabled"
                            }`}
                          onClick={startAndStopScrolling}
                        >
                          Start Optmizing
                        </Button>
                      </div>

                      {pdfData.file_type == "ebook" && templateAllVersion == 1
                        ? null
                        : (!pdfData?.isPharmaOwner ||
                          pdfData?.isPharmaOwner !== 1) && (
                          <Button
                            className="btn btn-bordered"
                            onClick={handleShow}
                          >
                            Change content file
                          </Button>
                        )}
                    </div>
                    <div className="new_preview_pdflink">
                      {newTemplateClicked ? (
                        pdfData?.file_type && pdfData.file_type == "ebook" ? (
                          <>
                            <RenderPdf
                              next={nextFlag}
                              url={
                                templateAllVersion == 1
                                  ? path_image + "videotypeebook.pdf"
                                  : templatePdf
                              }
                              draft={pdfData?.delete_status}
                              handleNext={handleNext}
                              hidePopup="0"
                              trigger={trigger}
                              updatePublish={updatePublish}
                              editStatus={isEdit}
                              customKey={isKey}
                              scrolling={scrolling}
                              setScrolling={setScrolling}
                              isDisableButton={isDisableButton}
                              setButton={setButton}
                              optimizeStatus={isOptimizingStart}
                            />
                          </>
                        ) : (
                          <RenderPdf
                            next={nextFlag}
                            url={pdfData?.file_name}
                            draft={pdfData?.delete_status}
                            handleNext={handleNext}
                            hidePopup="0"
                            trigger={trigger}
                            updatePublish={updatePublish}
                            editStatus={isEdit}
                            scrolling={scrolling}
                            setScrolling={setScrolling}
                            isDisableButton={isDisableButton}
                            setButton={setButton}
                            optimizeStatus={isOptimizingStart}
                          />
                        )
                      ) : null}
                    </div>
                  </>
                </Col>
              </div>
            </div>
          </div>
          <Modal
            show={show}
            onHide={handleClose}
            className="send-confirm preview-content"
            id="download-qr"
          >
            <Modal.Header>
              <h5 className="modal-title" id="staticBackdropLabel">
                Change file
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                onClick={handleClose}
              ></button>
            </Modal.Header>
            <Modal.Body>
              <Form>
                {pdfData?.file_type && pdfData.file_type == "ebook" ? (
                  <div className="form-group">
                    <label htmlFor="">Chapter title </label>
                    <input
                      type="text"
                      placeholder="Type chapter title"
                      name="chapter_title"
                      className="form-control"
                      value={titleNew}
                      onChange={(e) =>
                      {
                        setTitleNew(e.target.value);
                        handleChange(e, "title");
                      }}
                    />
                  </div>
                ) : null}
                <div className="form-group">
                  <div className="upload-file-box">
                    <div className="box">
                      <input
                        type="file"
                        name="file-5[]"
                        id="file-5"
                        className="inputfile inputfile-5"
                        accept="application/pdf"
                        onChange={(e) => handleChange(e, "uploadFile")}
                      />
                      <label htmlFor="file-5">
                        <span>Choose Your File</span>
                      </label>
                      {userInputs?.uploadFile?.[0]?.name ? (
                        <p className="uploaded-file">
                          {userInputs?.uploadFile?.[0].name}
                        </p>
                      ) : (
                        <p>Upload your PDF</p>
                      )}
                    </div>
                  </div>
                </div>
              </Form>
            </Modal.Body>
            <div className="modal-footer">
              <button
                type="button"
                className={
                  updateFlag == 0
                    ? "btn btn-primary save btn-filled move-draft btn-disabled"
                    : "btn btn-primary save btn-filled move-draft"
                }
                onClick={uploadPdf}
              >
                Upload
              </button>
            </div>
          </Modal>
        </Row>
      </div>
    </Col>
  );
};

export default VwdPreviewContent;
